/*                                             */
/*                                                       */
import { DEV } from 'esm-env';
import { FILENAME } from '../../constants.js';
import { is_firefox } from './dom/operations.js';
import { ERROR_VALUE, BOUNDARY_EFFECT, EFFECT_RAN } from './constants.js';
import { define_property, get_descriptor } from '../shared/utils.js';
import { active_effect, active_reaction } from './runtime.js';

const adjustments = new WeakMap();

/**
 *
 */
export function handle_error(error) {
	var effect = active_effect;

	/*                                                        */
	if (effect === null) {
		/*                  */ (active_reaction).f |= ERROR_VALUE;
		return error;
	}

	if (DEV && error instanceof Error && !adjustments.has(error)) {
		adjustments.set(error, get_adjustments(error, effect));
	}

	if ((effect.f & EFFECT_RAN) === 0) {
		/*                                                           */
		/*                                                    */
		if ((effect.f & BOUNDARY_EFFECT) === 0) {
			if (!effect.parent && error instanceof Error) {
				apply_adjustments(error);
			}

			throw error;
		}

		/*                   */ (effect.b).error(error);
	} else {
		/*                                               */
		invoke_error_boundary(error, effect);
	}
}

/**
 *
 *
 */
export function invoke_error_boundary(error, effect) {
	while (effect !== null) {
		if ((effect.f & BOUNDARY_EFFECT) !== 0) {
			try {
				/*                   */ (effect.b).error(error);
				return;
			} catch (e) {
				error = e;
			}
		}

		effect = effect.parent;
	}

	if (error instanceof Error) {
		apply_adjustments(error);
	}

	throw error;
}

/**
 *
 *
 *
 */
function get_adjustments(error, effect) {
	const message_descriptor = get_descriptor(error, 'message');

	/*                                                                              */
	/*                                                               */
	if (message_descriptor && !message_descriptor.configurable) return;

	var indent = is_firefox ? '  ' : '\t';
	var component_stack = `\n${indent}in ${effect.fn?.name || '<unknown>'}`;
	var context = effect.ctx;

	while (context !== null) {
		component_stack += `\n${indent}in ${context.function?.[FILENAME].split('/').pop()}`;
		context = context.p;
	}

	return {
		message: error.message + `\n${component_stack}\n`,
		stack: error.stack
			?.split('\n')
			.filter((line) => !line.includes('svelte/src/internal'))
			.join('\n')
	};
}

/**
 *
 */
function apply_adjustments(error) {
	const adjusted = adjustments.get(error);

	if (adjusted) {
		define_property(error, 'message', {
			value: adjusted.message
		});

		define_property(error, 'stack', {
			value: adjusted.stack
		});
	}
}
